import { createFileRoute } from "@tanstack/react-router";
import { AuditLogView } from "@/components/views/audit/AuditLogView";

export const Route = createFileRoute("/audit")({
  component: AuditLogView,
});
